import * as React from 'react';
import { DataTable } from 'damco-components';
import { clearFormat, formatData } from 'utilities/util';
import {calculateTotalOfField} from 'views/job-costing/utils/CostAndRevenueHelpers';
interface ITableProps{
    id: string;
    data:any[];
    cols:any[];
    name: string;
    hasTotal?:boolean;
    linkAction?:(e:any)=> void,
    isCBL?:boolean
}
class Table extends React.Component<ITableProps> {

    public componentDidUpdate(props:any){
        const arrayFooters = [{
            fieldName: 'weight',
            footerTarget: 'totalWeight',
            float: 3
        },{
            fieldName: this.props.isCBL ? 'equipmentTotalVolume' : 'volume',
            footerTarget: 'totalVolume',
            float: 3
        },{
            fieldName: 'quantity',
            footerTarget: 'totalQuantity',
            float: 0
        },{
            fieldName: 'packages',
            footerTarget: 'totalPackages',
            float: 0
        },{
            fieldName: 'documentOnEquipmentVolume',
            footerTarget: 'totalEqVolume',
            float: 0
        },{
            fieldName: 'etOnEssoVolumeFactor',
            footerTarget: 'totalEssoVolume',
            float: 0
        },{
            fieldName: 'essoCblOnEtVolumeFactor',
            footerTarget: 'totalEtVolume',
            float: 0
        },{
            fieldName: 'essoEtOnCblVolumeFactor',
            footerTarget: 'totalCblVolume',
            float: 0
        }];
        if(this.props.hasTotal && this.props.data){
            arrayFooters.forEach((item: { fieldName: string, footerTarget: string, float: number}) => {
                const dataNoCancel = this.props.data.slice();
                const list = dataNoCancel.filter((entry:any) => {
                    return !entry.status || (entry.status && (entry.status.toLowerCase() !== 'cancelled' || entry.status.toLowerCase() !== 'canceled'))
                })
                const total = calculateTotalOfField(list, `${item.fieldName}`, 5, true);
                const firstElFooter = document.querySelector(`#${this.props.id} .rt-tfoot .rt-td`) as HTMLSpanElement;
                if(firstElFooter) {
                    firstElFooter.innerHTML = `<div><span class="level">Total</span></div>`
                }
                const elFooter:HTMLSpanElement = document.querySelector(`#${this.props.id} .rt-tfoot .${item.footerTarget} div span.data`) as HTMLSpanElement;
                if(elFooter) {
                    elFooter.innerText = clearFormat(total, item.float);
                }
            })
        }
    }

    public render() {
        const data = formatData(this.props.data);
        return (
            <div id={this.props.id}>
                <DataTable
                    id={`${this.props.name}-${Math.random()}`}
                    data={data}
                    columns={this.props.cols}
                    isEditable={false}
                    isExpandable={false}
                    isSelectable={false}
                    isSortable={true}
                    isResizable={true}
                    hasFooter={true}
                    showColumnOptions={true}
                    tableName={this.props.name}
                    showPagination={data && data.length>=10?true:false}
                    linkAction={this.props.linkAction}
                    defaultPageSize={10}
                />
            </div>
        );
    }
}

export default Table;